import { fetchCourseCommentList } from '@/api/app/course';
export default {
  data() {
    return {
      courseCoursewareId: undefined, // courseCourseware id
      postId: undefined,
      courseCoursewareCommentLoaded: false,
      courseCoursewareCommentData: [],
      courseCoursewareCommentPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
    }
  },
  mounted() {
    this.courseCoursewareCommentLoaded = false;
  },
  methods: {
    initCourseCoursewareComment() {
      if (this.courseCoursewareCommentLoaded) {
        return;
      }

      this.getCourseCoursewareCommentList();
    },
    getCourseCoursewareCommentList() {
      this.courseCoursewareCommentLoaded = true;
      let params = {
        current: this.courseCoursewareCommentPage.currentPage,
        size: this.courseCoursewareCommentPage.pageSize,
        courseCoursewareId: this.courseCoursewareId,
        postId: this.postId
      }
      fetchCourseCommentList(params).then(response => {
        if (response.data.data != null) {
          this.courseCoursewareCommentData = response.data.data.records;
          this.courseCoursewareCommentData.forEach(comment => {
            comment.commentByName = comment.commentBy.name
            comment.banComment = comment.isBanned ? comment.banComment : "--";
            comment.commentByRealname = comment.commentBy.memberType === 1
              ? comment.commentBy.relatedPersonalRealname
              : comment.commentBy.realname;
            if (comment.commentTo) {
              comment.commentToName = comment.commentTo.name;
              comment.commentToRealname = comment.commentTo.realname;
            } else {
              comment.commentToName = '--';
              comment.commentToRealname = '--';
            }
          })
          this.courseCoursewareCommentPage.total = response.data.data.total;
        } else  {
          this.courseCoursewareCommentData = null;
          this.courseCoursewareCommentPage.total = 0;
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取该课时的评论列表失败',
          type: 'error'
        })
      });
      this.courseCoursewareCommentLoaded = false;
    },
    courseCoursewareCommentCurrentChange(val) {
      this.courseCoursewareCommentPage.currentPage = val;
      this.getCourseCoursewareCommentList();
    },
    courseCoursewareCommentSizeChange(val) {
      this.courseCoursewareCommentPage.pageSize = val;
      this.getCourseCoursewareCommentList();
    },
  }
}
